import {fromLonLat as olFromLonLat, toLonLat as olToLonLat} from 'ol/proj';

// 定义一些常量
const x_PI = 3.14159265358979324 * 3000.0 / 180.0;
const PI = 3.1415926535897932384626;
const a = 6378245.0;
const ee = 0.00669342162296594323;
/**
 * 百度坐标系 (BD-09) 与 火星坐标系 (GCJ-02)的转换
 * 即 百度 转 谷歌、高德
 * @param bd_lon
 * @param bd_lat
 * @returns {*[]}
 */
export function bd09togcj02(bd_lon, bd_lat) {
    bd_lon = +bd_lon;
    bd_lat = +bd_lat;
    const x = bd_lon - 0.0065;
    const y = bd_lat - 0.006;
    const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_PI);
    const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_PI);
    const gg_lng = z * Math.cos(theta);
    const gg_lat = z * Math.sin(theta);
    return [gg_lng, gg_lat];
}

/**
 * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换
 * 即谷歌、高德 转 百度
 * @param lng
 * @param lat
 * @returns {*[]}
 */
export function gcj02tobd09(lng, lat) {
    lat = +lat;
    lng = +lng;
    const z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
    const theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
    const bd_lng = z * Math.cos(theta) + 0.0065;
    const bd_lat = z * Math.sin(theta) + 0.006;
    return [bd_lng, bd_lat];
}

/**
 * WGS84转GCj02
 * @param lng
 * @param lat
 * @returns {*[]}
 */
export function wgs84togcj02(lng, lat) {
    lat = +lat;
    lng = +lng;
    if (out_of_china(lng, lat)) {
        return [lng, lat];
    } else {
        let dlat = transformlat(lng - 105.0, lat - 35.0);
        let dlng = transformlng(lng - 105.0, lat - 35.0);
        const radlat = lat / 180.0 * PI;
        let magic = Math.sin(radlat);
        magic = 1 - ee * magic * magic;
        const sqrtmagic = Math.sqrt(magic);
        dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
        dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
        const mglat = lat + dlat;
        const mglng = lng + dlng;
        return [mglng, mglat];
    }
}

/**
 * GCJ02 转换为 WGS84
 * @param lng
 * @param lat
 * @returns {*[]}
 */
export function gcj02towgs84(lng, lat) {
    lat = +lat;
    lng = +lng;
    if (out_of_china(lng, lat)) {
        return [lng, lat]
    } else {
        let dlat = transformlat(lng - 105.0, lat - 35.0);
        let dlng = transformlng(lng - 105.0, lat - 35.0);
        const radlat = lat / 180.0 * PI;
        let magic = Math.sin(radlat);
        magic = 1 - ee * magic * magic;
        const sqrtmagic = Math.sqrt(magic);
        dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
        dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
        const mglat = lat + dlat;
        const mglng = lng + dlng;
        return [lng * 2 - mglng, lat * 2 - mglat];
    }
}

function transformlat(lng, lat) {
    lat = +lat;
    lng = +lng;
    let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
    ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lat * PI) + 40.0 * Math.sin(lat / 3.0 * PI)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(lat / 12.0 * PI) + 320 * Math.sin(lat * PI / 30.0)) * 2.0 / 3.0;
    return ret
}

function transformlng(lng, lat) {
    lat = +lat;
    lng = +lng;
    let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
    ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lng * PI) + 40.0 * Math.sin(lng / 3.0 * PI)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(lng / 12.0 * PI) + 300.0 * Math.sin(lng / 30.0 * PI)) * 2.0 / 3.0;
    return ret;
}

/**
 * 判断是否在国内，不在国内则不做偏移
 * @param lng
 * @param lat
 * @returns {boolean}
 */
function out_of_china(lng, lat) {
    lat = +lat;
    lng = +lng;
    // 纬度3.86~53.55,经度73.66~135.05
    return !(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55);
}

export function wgs84ToBd09(point) {
    const gcj02 = wgs84togcj02(point.lng, point.lat);
    const bd09 = gcj02tobd09(gcj02[0], gcj02[1]);
    point.lng = bd09[0];
    point.lat = bd09[1];
}

export function batchWgs84ToBd09(points) {
    for (let i = 0; i < points.length; i++) {
        wgs84ToBd09(points[i]);
    }
}

export function bd09ToWgs84(point) {
    const gcj02 = bd09togcj02(point.lng, point.lat);
    const wgs84 = gcj02towgs84(gcj02[0], gcj02[1]);
    point.lng = wgs84[0];
    point.lat = wgs84[1];
}

export function batchBd09ToWgs84(points) {
    for (let i = 0; i < points.length; i++) {
        bd09ToWgs84(points[i]);
    }
}

const array1 = [75, 60, 45, 30, 15, 0];
const array3 = [12890594.86, 8362377.87, 5591021, 3481989.83, 1678043.12, 0];
const array2 = [[-0.0015702102444, 111320.7020616939, 1704480524535203, -10338987376042340, 26112667856603880
    , -35149669176653700, 26595700718403920, -10725012454188240, 1800819912950474, 82.5]
    , [0.0008277824516172526, 111320.7020463578, 647795574.6671607, -4082003173.641316, 10774905663.51142
        , -15171875531.51559, 12053065338.62167, -5124939663.577472, 913311935.9512032, 67.5]
    , [0.00337398766765, 111320.7020202162, 4481351.045890365, -23393751.19931662, 79682215.47186455, -115964993.2797253
        , 97236711.15602145, -43661946.33752821, 8477230.501135234, 52.5]
    , [0.00220636496208, 111320.7020209128, 51751.86112841131, 3796837.749470245, 992013.7397791013, -1221952.21711287
        , 1340652.697009075, -620943.6990984312, 144416.9293806241, 37.5]
    , [-0.0003441963504368392, 111320.7020576856, 278.2353980772752, 2485758.690035394, 6070.750963243378
        , 54821.18345352118, 9540.606633304236, -2710.55326746645, 1405.483844121726, 22.5]
    , [-0.0003218135878613132, 111320.7020701615, 0.00369383431289, 823725.6402795718, 0.46104986909093
        , 2351.343141331292, 1.58060784298199, 8.77738589078284, 0.37238884252424, 7.45]];
const array4 = [[1.410526172116255e-8, 0.00000898305509648872, -1.9939833816331, 200.9824383106796, -187.2403703815547
    , 91.6087516669843, -23.38765649603339, 2.57121317296198, -0.03801003308653, 17337981.2]
    , [-7.435856389565537e-9, 0.000008983055097726239, -0.78625201886289, 96.32687599759846, -1.85204757529826
        , -59.36935905485877, 47.40033549296737, -16.50741931063887, 2.28786674699375, 10260144.86]
    , [-3.030883460898826e-8, 0.00000898305509983578, 0.30071316287616, 59.74293618442277, 7.357984074871
        , -25.38371002664745, 13.45380521110908, -3.29883767235584, 0.32710905363475, 6856817.37]
    , [-1.981981304930552e-8, 0.000008983055099779535, 0.03278182852591, 40.31678527705744, 0.65659298677277
        , -4.44255534477492, 0.85341911805263, 0.12923347998204, -0.04625736007561, 4482777.06]
    , [3.09191371068437e-9, 0.000008983055096812155, 0.00006995724062, 23.10934304144901, -0.00023663490511
        , -0.6321817810242, -0.00663494467273, 0.03430082397953, -0.00466043876332, 2555164.4]
    , [2.890871144776878e-9, 0.000008983055095805407, -3.068298e-8, 7.47137025468032, -0.00000353937994
        , -0.02145144861037, -0.00001234426596, 0.00010322952773, -0.00000323890364, 826088.5]];

// 百度坐标转墨卡托
export function latLng2Mercator(p) {
    let arr = null;
    let n_lat = Math.min(74, Math.max(-74, p.lat));
    let i;
    for (i = 0; i < array1.length; i++) {
        if (n_lat >= array1[i]) {
            arr = array2[i];
            break;
        }
    }
    if (arr === null) {
        for (i = 0; i < array1.length; i++) {
            if (n_lat <= -array1[i]) {
                arr = array2[i];
                break;
            }
        }
    }
    let res = convert(p.lng, n_lat, arr);
    return {x: +res[0].toFixed(2), y: +res[1].toFixed(2)};
}

// 墨卡托坐标转百度
export function mercator2LatLng(p) {
    let arr = null;
    let np = {x: Math.abs(p.x), y: Math.abs(p.y)};
    let i;
    for (i = 0; i < array3.length; i++) {
        if (np.y >= array3[i]) {
            arr = array4[i];
            break;
        }
    }
    let res = convert(p.x, p.y, arr);
    return {lng: +res[0].toFixed(6), lat: +res[1].toFixed(6)};
}

function convert(x, y, param) {
    let T = param[0] + param[1] * Math.abs(x);
    let cC = Math.abs(y) / param[9];
    let cF = param[2] + param[3] * cC + param[4] * cC * cC + param[5] * cC * cC * cC + param[6] * cC * cC * cC * cC
        + param[7] * cC * cC * cC * cC * cC + param[8] * cC * cC * cC * cC * cC * cC;
    T *= (x < 0 ? -1 : 1);
    cF *= (y < 0 ? -1 : 1);
    return [T, cF];
}

export function lonLat2WebMercator(lon, lat) {
    let x = lon * 20037508.3427892 / 180;
    let y = Math.log(Math.tan((90 + lat) * Math.PI / 360)) / (Math.PI / 180);
    y = y * 20037508.3427892 / 180;
    return [x, y];
}

export function webMercator2LonLat(x, y) {
    let lon = x * 180 / 20037508.3427892;
    let ty = y * 180 / 20037508.3427892;
    let lat = Math.atan(Math.exp(ty * (Math.PI / 180))) * 360 / Math.PI - 90;
    return [lon, lat];
}

const ratio = (256 * Math.pow(2, 19)) / (20037508.3427892 * 2);

export function lonLat2Coordinate(lon, lat) {
    let gcj = wgs84togcj02(lon, lat);
    let mercator = lonLat2WebMercator(gcj[0], gcj[1]);
    let x = (20037508.3427892 + mercator[0]) * ratio;
    let y = (20037508.3427892 - mercator[1]) * ratio;
    return [Math.round(x), Math.round(y)];
}

export function coordinate2LonLat(x, y) {
    let mx = x / ratio - 20037508.3427892;
    let my = 20037508.3427892 - y / ratio;
    let gcj = webMercator2LonLat(mx, my);
    return gcj02towgs84(gcj[0], gcj[1]);
}

export function fromLonLat(lonLat, opt_projection) {
    lonLat = wgs84togcj02(lonLat[0], lonLat[1]);
    return olFromLonLat(lonLat, opt_projection);
}

export function toLonLat(coordinate, opt_projection) {
    let lonLat = olToLonLat(coordinate, opt_projection);
    return gcj02towgs84(lonLat[0], lonLat[1]);
}
